import React from 'react';

import Button, { type ButtonBaseProps } from './Button';
import { IconCloseX } from '@icons';

export interface ButtonCloseProps
  extends ButtonBaseProps,
    Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type' | keyof ButtonBaseProps> {
  buttonID?: string;
  type?: 'button' | 'submit' | 'reset';
  'aria-label'?: string;
}

const ButtonClose: React.FC<ButtonCloseProps> = ({
  buttonID,
  className = '',
  label,
  icon,
  iconPosition,
  type,
  'aria-label': ariaLabel,
  ...rest
}) => {
  const classes = `btn-ghost btn-icon${className ? ' ' + className : ''}`;
  return (
    <Button
      {...rest}
      className={classes}
      type={(type as 'button' | 'submit' | 'reset') ?? 'button'}
      label={label ?? <IconCloseX />}
      icon={icon}
      iconPosition={iconPosition}
      aria-label={ariaLabel ?? 'Close'}
      id={buttonID}
    />
  );
};

export default ButtonClose;
